var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMinhasAtividades(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m1.2 0c-0.66274 0-1.2 0.53726-1.2 1.2 0 0.66274 0.53726 1.2 1.2 1.2v12c-0.66274 0-1.2 0.53724-1.2 1.2s0.53726 1.2 1.2 1.2h5.838l-4.3598 5.2318c-0.42427 0.50916-0.35549 1.2659 0.15365 1.6901 0.50914 0.42432 1.2658 0.35556 1.6901-0.1536l5.6402-6.7682h3.7409l6.8485 6.8485c0.4686 0.4686 1.2284 0.4686 1.697 0s0.4686-1.2284 0-1.697l-5.1515-5.1515h5.503c0.66276 0 1.2-0.53724 1.2-1.2s-0.53724-1.2-1.2-1.2v-12c0.66276 0 1.2-0.53726 1.2-1.2 0-0.66274-0.53724-1.2-1.2-1.2zm13.201 14.4h5.9992v-12h-16.8v12h10.799zm-9.6008-9.3c0-0.49705 0.40295-0.9 0.9-0.9h5.4c0.49705 0 0.9 0.40295 0.9 0.9s-0.40295 0.9-0.9 0.9h-5.4c-0.49705 0-0.9-0.40295-0.9-0.9zm0.9 2.7c-0.49705 0-0.9 0.40295-0.9 0.9s0.40295 0.9 0.9 0.9h5.4c0.49705 0 0.9-0.40295 0.9-0.9s-0.40295-0.9-0.9-0.9zm-0.9 4.5c0-0.49705 0.40295-0.9 0.9-0.9h12.6c0.49704 0 0.9 0.40295 0.9 0.9 0 0.49704-0.40296 0.9-0.9 0.9h-12.6c-0.49705 0-0.9-0.40296-0.9-0.9zm9.6-7.5h3.6v3.6h-3.6zm-1.2 0c0-0.66274 0.53724-1.2 1.2-1.2h3.6c0.66276 0 1.2 0.53726 1.2 1.2v3.6c0 0.66274-0.53724 1.2-1.2 1.2h-3.6c-0.66276 0-1.2-0.53726-1.2-1.2z",
    clipRule: "evenodd",
    color: "#000000",
    fill: "#7fb539",
    fillRule: "evenodd",
    strokeWidth: 1.2,
    style: {
      InkscapeStroke: "none"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinhasAtividades);
export default __webpack_public_path__ + "static/media/minhas_atividades.16dfc94e.svg";
export { ForwardRef as ReactComponent };